import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Container } from "react-bootstrap";
import { selectAuth } from "../../components/auth/auth.selector";
import "../../styles/pt/pt-trials.css";
import HelmetWrapper from "../../HelmetWrapper";
import PTTrackStructure from "../../components/pt-trials/PTTrackStructure";

const PTTrialTrack = () => {
  const userInfo = useSelector(selectAuth);
  const [decryptedText, setDecryptedText] = useState(userInfo?.user || {});

  useEffect(() => {
    if (userInfo?.isAuthenticated && userInfo?.user) {
      setDecryptedText(userInfo.user);
    }
  }, [userInfo]);

  return (
    <HelmetWrapper title="PT Track System">
      <Container className="bg-cloud-k px-50px" fluid>
        <PTTrackStructure decryptedText={decryptedText} />
      </Container>
    </HelmetWrapper>
  );
};

export default PTTrialTrack;
